module.exports = __webpack_public_path__ + "img/195-Gris Béton Structuré.jpg";